/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSystemInfo: BridgeCommands.Command<
    Types.Common.Systeminfo.GetSystemInfoParameters,
    Types.Common.Systeminfo.SystemInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'SystemInfo',
    method: 'GetSystemInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetClientHeadersInfo: BridgeCommands.Command<
    Types.Common.Systeminfo.GetClientHeadersInfoParameters,
    Types.Common.Systeminfo.SystemInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'SystemInfo',
    method: 'GetClientHeadersInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDeviceId: BridgeCommands.Command<
    {},
    Types.Common.Systeminfo.DeviceIDInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'SystemInfo',
    method: 'GetDeviceId',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBrowserInfo: BridgeCommands.Command<
    {},
    Types.Common.Systeminfo.BrowserInfo
    > = {
    legacyCommand: 'QUERY_BROWSER_INFO',
    system: 'CrimsonNative',
    module: 'SystemInfo',
    method: 'GetBrowserInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetStreamingSupportInfo: BridgeCommands.Command<
    {},
    Types.Common.Systeminfo.StreamingSupportInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'SystemInfo',
    method: 'GetStreamingSupportInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNetworkTypeChangedInfo: BridgeCommands.Command<
    {},
    Types.Common.Systeminfo.NetworkTypeChangedInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'SystemInfo',
    method: 'GetNetworkTypeChangedInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DNSLookup: BridgeCommands.Command<
    Types.Common.Systeminfo.DNSLookupParameters,
    any
    > = {
    legacyCommand: 'QUERY_DNS',
    system: 'CrimsonNative',
    module: 'SystemInfo',
    method: 'DNSLookup',
    persistent: false
};

export const Systeminfo = {
GetSystemInfo,
GetClientHeadersInfo,
GetDeviceId,
GetBrowserInfo,
GetStreamingSupportInfo,
GetNetworkTypeChangedInfo,
DNSLookup
};
